import React, { useEffect, useState } from "react";
import CustomEventList from "../../reusable/CustomEventList";
import { getCancelledEvents } from "../../../utils/ApiFunctions";
import moment from "moment";
import { useDispatch } from "react-redux";
import { linkActions } from "../../store";
import Loader from "../../reusable/Loader";
import NoData from "../../reusable/NoData";

function Cancelled(props) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState("");
  const dispatch = useDispatch();

  const getAllEvents = async () => {
    const resp = await getCancelledEvents();
    if (resp) {
      setTotalPages(resp.totalPages);
      const temp = resp.data.events?.map((event) => ({
        _id: event._id,
        name: event.eventName,
        date: moment(event.date).format("YYYY-MM-DD"),
        // time: `${moment(event.fromTime).format("HH:mm")}-${moment(
        //   event.toTime
        // ).format("HH:mm")}`,
        time : `${event.fromTime} - ${event.toTime}`,
        assignedTo: event.contactPerson,
        employees: event.noOfParticipants,
        format: event.eventFormat,
        court: event.court.map((c) => `${c.name}`).join(", "),
        status: event.status,
        paymentStatus: event.paymentStatus,
      }));
      setEvents(temp);
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    getAllEvents();
    dispatch(linkActions.setTo("/admin/eventheader/cancelled"));
  }, [page]);

  return (
    <>
      {loading && <Loader />}
      {!loading && !events[0] &&
        <NoData title={"No Cancelled Events"} subtitle={"Wait for the events to cancel."} />
      }
      {!loading && events[0] && (
        <CustomEventList
          responsive={'tableTabletAdminEvents'}
          events={events}
          page={page}
          setPage={setPage}
          eventstate={"cancelled"}
          totalPages={totalPages}
        />
      )}
    </>
  );
}

export default Cancelled;
